var render = function render(){var _vm=this,_c=_vm._self._c;return _c('treeselect',{attrs:{"multiple":true,"options":_vm.devices.nodes,"limit":1,"match-keys":['label', 'project']},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }